import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import 'src/layouts/index.css';
import useStateRef from "react-usestateref";
import EventEmitter from 'src/utils/EventEmitter';

const MainLayout2 = () => {
  /* eslint-disable */
  const [initialized, setInitialized] = useState(false);
  const [showTopNavigation, setShowTopNavigation, showTopNavigationRef] = useStateRef(false);
  /* eslint-enable */

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!initialized) {
      setInitialized(true);

      const splash = document.querySelectorAll('.splash');
      setTimeout(() => {
        for (var i = 0; i < splash.length; ++i) {
          splash[i].classList.add('display-none');
        }
      }, 500)
    }


    const onShowTopNavigation = (eventData) => {
      setShowTopNavigation(eventData.value);
    }

    const listener = EventEmitter.addListener('show_top_navigation', onShowTopNavigation);

    return () => {
      listener.remove();
    }
  });

  useEffect(() => {
    checkLocation();
  }, [window.location.pathname]);

  const checkLocation = () => {
    const location = window.location.pathname;

    if (location === "/forgot-password" || location === "/update-email" || location === "/user-verification") {
      setShowTopNavigation(true);
    } else {
      setShowTopNavigation(false);
    }

    // if (location === "/forgot-password" || location === "/update-email" || location === "/user-verification") {
    //   setShowTopNavigation(true);
    // } else {
    //   setShowTopNavigation(false);
    // }
  }

  const onClickBackArrow = () => {
    EventEmitter.emit("prev_step", { value: true });
  }

  return (
    <div style={{ height: "100%", width: "100%", minHeight: "-webkit-fill-available", minWidth: "-webkit-fill-available" }}>

      {showTopNavigationRef.current ?
        <div className="back_arrow back-arrow-2"><i className="icon-arrow-left" style={{ fontSize: "16px" }} onClick={() => onClickBackArrow()}></i></div>
        : ''
      }
      <Outlet />
      <div style={{ height: "20px", minHeight: "20px" }}></div>
    </div>
  );
};

export default MainLayout2;